<template>
  <Card dis-hover>
    <div slot="title">
      <slot name="title"></slot>
      <p class="title-item">{{ this.$t('common.this_month') }}</p>
    </div>
    <a href="#" slot="extra">
      <slot name="extra"></slot>
    </a>
    <div class="content">
      <div id="score-distribution-secret-items"></div>
    </div>
  </Card>
</template>
<script>
import * as echarts from 'echarts';
import api from '../../../api/home/index';
import moment from 'moment';
import { tooltipRefash } from '../echartUtil';
export default {
  components: {},
  props: {},
  computed: {},
  data() {
    return {
      myChart: null,
      timer: null,
    };
  },
  mounted() {
    this.getData();
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    myEchartsResize() {
      this.myChart && this.myChart.resize();
    },
    async getData() {
      let startTime = moment().month(moment().month()).startOf('month').format('YYYY-MM-DD HH:mm:ss');
      let endTime = moment().month(moment().month()).endOf('month').format('YYYY-MM-DD HH:mm:ss');
      let res = await api.getShopScoreRate({ startTime, endTime });
      let keyMapColor = ['#5B8FF9', '#FF99C3', '#5D7092', '#5AD8A6', '#F6BD15', '#E8694A'];
      res.legend = res.legend.slice(0, 6);
      let legend = res.legend.map((i, index) => {
        return {
          value: res.value[index],
          name: i,
          itemStyle: {
            color: keyMapColor[index],
          },
        };
      });
      res.value = res.value.slice(0, 6);
      let valueArr = res.value.map((i, index) => {
        return {
          value: Math.abs(i),
          num: i,
          name: res.legend[index],
          itemStyle: {
            color: keyMapColor[index],
          },
        };
      });

      let chartDom = document.getElementById('score-distribution-secret-items');
      this.myChart = echarts.init(chartDom);
      let option = {
        grid: {
          containLabel: true,
        },
        tooltip: {
          trigger: 'item',
          position: 'right',
          valueFormatter: value => {
            return valueArr.find(i => i.value === value).num;
          },
        },
        legend: {
          orient: 'vertical',
          itemWidth: 10,
          itemHeight: 10,
          icon: 'circle',
          right: '10',
          top: 'center',
          textStyle: {
            fontSize: 13,
            color: '#999999',
          },
          data: legend,
          formatter: function (name) {
            const len = name.length;
            if (len > 10) {
              name = name.slice(0, 10) + '...';
            }
            return name;
          },
        },
        series: [
          {
            minAngle: 22,
            avoidLabelOverlap: true,
            type: 'pie',
            radius: '65%',
            center: ['30%', '50%'],
            label: {
              position:"outside",
              formatter: '{a|{d}%}',
              padding: [0, -40],
              rich: {
                a: {
                  color: '#E6E6E6',
                  fontSize: 12,
                  padding: [2, 4, -10],
                },
              },
            },
            labelLine: {
              length: 20,
              length2: 40,
              show: true,
              lineStyle: {
                color: '#CCCCCC',
                width: 2,
              },
            },
            data: valueArr,
          },
        ],
      };
      // 绘制图表
      this.myChart.setOption(option);
      let dataLen = valueArr.length;
      this.timer = tooltipRefash(this.myChart, dataLen);
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep {
  .ivu-card-head p {
    width: auto;
  }
}
.title-item {
  padding: 0 5px;
  height: 18px;
  background: rgba(255, 255, 255, 0.11);
  border-radius: 3px;
  font-family: PingFangSC-Semibold;
  font-weight: 600;
  font-size: 12px;
  color: #b2b2b2;
  letter-spacing: 0;
  line-height: 16px;
  text-align: center;
  margin-left: 6px;
}

.content {
  height: 100%;
  #score-distribution-secret-items {
    width: 100%;
    height: 100%;
  }
}
</style>
